@if (config) {
  <div
    #tooltipEl
    class="TooltipWrapper"
    [attr.aria-controls]="trackById"
    [attr.aria-expanded]="!!(tooltipService.instances$ | async)[trackById]"
  >
    @if (config.description) {
      <zip-button
        [config]="{
          level: 'text',
          icon: getIconName((tooltipService.instances$ | async)[trackById]),
        }"
        [iconSize]="config.size ? config.size : 'medium'"
        [iconFormat]="config.format ? config.format : 'svg'"
        (click)="toggleTooltip($event)"
        dataClickEvent
        aria-label="Toggle tooltip"
      >
      </zip-button>
    }
    @if ((tooltipService.instances$ | async)[trackById]) {
      <div
        class="TooltipPointer"
        [ngClass]="{ TooltipDirectionTopPointer: config.directionTop }"
      ></div>
    }
    @if ((tooltipService.instances$ | async)[trackById]; as show) {
      <p
        [style.marginLeft.px]="tooltipMarginLeft"
        tabindex="0"
        class="Tooltip t-html"
        [ngClass]="{
          TooltipLeftFlow: config.leftAlign,
          TooltipDirectionTop: config.directionTop,
        }"
        [attr.id]="trackById"
        [innerHTML]="config?.description"
        [@popup]="{ value: show, params: { transformOrigin: transformOrigin } }"
      ></p>
    }
  </div>
}
